import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14.518,
	height: 21.173,
	viewBox: "0 0 14.518 21.173",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "flash-thunder-outline-icon",
		d: "M297.415,422.407l-4.876-.46a.369.369,0,0,1-.335-.4.381.381,0,0,1,.035-.128l4.436-9.725a.37.37,0,0,1,.337-.218H303.1a.372.372,0,0,1,.3.593l-3.122,5.061,5.606.617a.371.371,0,0,1,.229.624l-11.372,13.644a.37.37,0,0,1-.633-.361Zm-4.288-1.148,4.8.453a.348.348,0,0,1,.12.021.372.372,0,0,1,.225.475l-2.759,7.727,9.609-11.528-5.5-.605a.389.389,0,0,1-.154-.054.371.371,0,0,1-.12-.509l3.1-5.021h-5.2Z",
		transform: "translate(-291.952 -411.224)",
		fill: "var(--ant-primary-color)",
		stroke: "var(--ant-primary-color)",
		strokeWidth: .5
	})]
});
const ForwardRef = forwardRef(SvgFlash);
export default ForwardRef;
